export default {
  state: {
    auditQuery: null,
    areaQuery: null,
    clauseCategoryQuery: null,
    clauseQuery: null,
    scopeQuery: null,
    scoringQuery: null,
    gradeQuery: null,
    auditTypeQuery: null,
    formTemplateQuery: null
  },
  mutations: {
    setAuditPageQuery(state, payload) {
      state.auditQuery = payload
    },
    setAreaPageQuery(state, payload) {
      state.areaQuery = payload
    },
    setScopePageQuery(state, payload) {
      state.scopeQuery = payload
    },
    setClausePageQuery(state, payload) {
      state.clauseQuery = payload
    },
    setClauseCategoryPageQuery(state, payload) {
      state.clauseCategoryQuery = payload
    },
    setScoringPageQuery(state, payload) {
      state.scoringQuery = payload
    },
    setGradePageQuery(state, payload) {
      state.gradeQuery = payload
    },
    setAuditTypePageQuery(state, payload) {
      state.auditTypeQuery = payload
    },
    setFormTemplatePageQuery(state, payload) {
      state.formTemplateQuery = payload
    }
  },
  actions: {},
  getters: {
    getAuditPageQuery(state) {
      return state.auditQuery
    },
    getAreaPageQuery(state) {
      return state.areaQuery
    },
    getClauseCategoryPageQuery(state) {
      return state.clauseCategoryQuery
    },
    getClausePageQuery(state) {
      return state.clauseQuery
    },
    getScopePageQuery(state) {
      return state.scopeQuery
    },
    getScoringPageQuery(state) {
      return state.scoringQuery
    },
    getGradePageQuery(state) {
      return state.gradeQuery
    },
    getAuditTypePageQuery(state) {
      return state.auditTypeQuery
    },
    getFormTemplatePageQuery(state) {
      return state.formTemplateQuery
    }
  }
}
